// 全部渲染完毕后 停止
export const useDefer = (max: number) => {
    const count = ref(0)
    const update = ()=>{
        count.value++
        if(count.value > max){
            return 
        }
        requestAnimationFrame(update)
    }
    onMounted(()=>{
        update()
    })
    return (n: number) =>  {
        return count.value >= n
    }
}